import { useGetUserCredentialsQuery } from '@sketch/gql-types'

const useUserSignedIn = () => {
  const { data } = useGetUserCredentialsQuery({
    fetchPolicy: 'cache-only',
  })
  return !!data?.userCredentials?.authToken
}
export default useUserSignedIn
